'use strict'

import Helper from '@/utils/helper'
import AdTextItem from '@/app/service/api/model/ad/ad-item-type/ad-text-item'
import AdItem from '@/app/service/api/model/ad/ad-item-type/ad-item'
import AdAudioItem from '@/app/service/api/model/ad/ad-item-type/ad-audio-item'

class AdPlaylist {
  constructor ({ textItems, items, audioItems }) {
    if (Helper.isDefined(textItems)) {
      Helper.checkNotEmptyArray('AdvPlaylist.textItems', textItems)
    }

    if (Helper.isDefined(items)) {
      Helper.checkNotEmptyArray('AdvPlaylist.items', items)
    }

    if (Helper.isDefined(audioItems)) {
      Helper.checkNotEmptyArray('AdvPlaylist.audioItems', audioItems)
    }

    this.textItems = textItems ? textItems.map(textItem => new AdTextItem(textItem)) : null
    this.items = items ? items.map(item => new AdItem(item)).filter(elem => elem.type !== 1) : null
    this.audioItems = audioItems ? audioItems.map(audioItem => new AdAudioItem(audioItem)) : null
  }

  getTextItems () {
    return this.textItems
  }

  getItems () {
    return this.items
  }

  getAudioItems () {
    return this.audioItems
  }

  toString () {
    return 'AdPlaylist{' +
      'textItems=' + '\'' + this.textItems + '\'' +
      'items=' + '\'' + this.items + '\'' +
      'audioItems=' + '\'' + this.audioItems + '\'' +
      '}'
  }
}

export default AdPlaylist
